import _ from 'lodash'
import $ from 'jquery'
import ScorecardReportResults from 'scoreboard/reports/scorecard-report/scorecard-report-results'
import template from './mass-edit-report-results.hbs'
import selectAllTemplate from './select-all.hbs'
import MassEditTableModel from './mass-edit-table-model'
import buildMetricTooltip from 'scoreboard/home/build-metric-tooltip'
import arrayToHash from 'scoreboard/components/array-to-hash'
import { NO_SELECT_CLASS } from 'scoreboard/reports/common/table/header-cell'

const MassEditReportResults = ScorecardReportResults.extend({

	className: 'mass-edit-results reports-overview report',

	events: {
		'change input[type=checkbox].select-all': '_onClickToggleAllCheckbox',
		'change tbody.data input[type=checkbox]': '_onClickItemCheckbox'
	},

	initialize(options = {}) {
		ScorecardReportResults.prototype.initialize.apply(this, arguments)
		// #45554 prevent sort warning tooltip until sorting is implemented
		this.viewModel.showSortWarning = false
	},

	/**
	 * @override base-report-results.js to avoid listeners that are not
	 * needed for 'Admin/Mass Edit Scorecard Items' and result in
	 * "Maximum call stack size exceeded" (#48387)
	 **/
	_setupListeners: function () {
		this.tableModel.on('data', this.onData.bind(this))
	},

	_template: function(ctx) {
		return template(ctx)
	},

	_viewModel: function() {
		//#43606 for mass edit, we don't want to clone here because #42604 does
		//not apply here and a cloned model will cause the table model to
		//be listening on the wrong model
		return this.model
	},

	_reportTableModel() {
		return MassEditTableModel
	},

	render: function() {
		ScorecardReportResults.prototype.render.apply(this, arguments)
		//do not use the toggle-all-checkboxes.js it does not perform well under
		//a large number of boxes due to the css selector used in the event binding
		return this
	},

	onData: function(data) {
		// if there is a "no results message but we are still seeing the columns
		// don't add the checkboxes
		if (this.$('.has-data-message').length) {
			return
		}

		// add the select all checkbox to the first header row td
		this.$('tr.header-row:first td:first-child')
			.addClass(NO_SELECT_CLASS)
			.find('.content').empty().append(selectAllTemplate({}))
			.find('input:checkbox.select-all').prop('checked', this.toggleAll)
		this.buildTooltips(data)
		this.updateDom()
	},

	_onClickToggleAllCheckbox: function(e) {
		this.toggleAll = $(e.target).prop('checked')
		// #50155 Use this.parent.allIds when toggling on all checkboxes, because
		// it's possible that not all the items have been rendered in the DOM
		// yet (infinite scroll)
		this.parent.selectedItemIds = this.toggleAll ? _.clone(this.parent.allIds) : []
		this.updateDom()
	},

	_onClickItemCheckbox: function(e) {
		let checkbox = $(e.target)
		let itemId = _.toInteger(checkbox.val())
		if (checkbox.prop('checked') == false) {
			// If we just unchecked something, ensure that the "select all"
			// checkbox is unchecked
			this.$('input[type=checkbox].select-all').prop('checked', false)
			this.toggleAll = false

			// Remove the item from the stored state
			_.pull(this.parent.selectedItemIds, itemId)
		} else {
			// Add new item to the stored state
			this.parent.selectedItemIds.push(itemId)
		}
	},

	// add tooltips with id and description to labels
	buildTooltips: function(data) {
		// #40702 display description in tooltip
		// build a map of id to description from the data
		let idToDescriptions = new Map(data.map(
			datum => [_.get(datum, 'id'), _.get(datum, 'description.value')]))

		_.each(this.$('a.text-link'), label => {
			let id = $(label).data('item-id')
			let description = idToDescriptions.get(id)
			buildMetricTooltip(this.el, $(label), description, id)
		})
	},

	/**
	 * Updates the 'checked' state of the checkboxes using the state stored
	 * in this.parent.selectedItemIds
	 */
	updateDom: function() {
		let selectedValues = arrayToHash(this.parent.selectedItemIds)
		_.each(this.$('input:checkbox:not(.select-all)'), (cbx) => {
			cbx.checked = !!selectedValues[cbx.value]
		})
	},

	_clearComponents() {
		ScorecardReportResults.prototype._clearComponents.apply(this, arguments)
		_.invoke(this.toggleAllCheckboxes, 'remove')
	}
})

export default MassEditReportResults
MassEditReportResults.__filename__ = 'admin/mass-edit/mass-edit-report-results.js'
